import { render, staticRenderFns } from "./signle-patient-data-use.html?vue&type=template&id=756535db&scoped=true&external"
import script from "./signle-patient-data-use.js?vue&type=script&lang=js&external"
export * from "./signle-patient-data-use.js?vue&type=script&lang=js&external"
import style0 from "./signle-patient-data-use.scss?vue&type=style&index=0&id=756535db&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756535db",
  null
  
)

export default component.exports